import {
  Module,
  VuexModule,
  getModule,
  Mutation,
  Action
} from "vuex-module-decorators";
import { Beneficiario } from "@/models/beneficiario";
import BeneficiarioAuthService from "@/services/beneficiario.auth.service";
import store from "@/store";

interface CpfNascimento {
  cpf: string;
  nascimento: string;
}

@Module({
  dynamic: true,
  namespaced: true,
  name: "beneficiario",
  store
})
class BeneficiarioModule extends VuexModule {
  beneficiario: Beneficiario;
  beneficiarioCpfNascimento: CpfNascimento;

  @Mutation
  setBeneficiario(beneficiario: Beneficiario): void {
    this.beneficiario = beneficiario;
  }

  @Mutation
  setBeneficiarioCpfNascimento(data: any): void {
    this.beneficiarioCpfNascimento = data;
  }
}

export default getModule(BeneficiarioModule);
